export default "__VITE_ASSET__DWmxI$NA__";